export class ConsentStatus {
  Code: number;
  Hint: string;
  IconClass: string;

  constructor() {
    this.Code = 0;
    this.Hint = "";
    this.IconClass = "";
  }
}
